import { notifications } from '@mantine/notifications';
import { replaceCampaignShortLink } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useReplaceCampaignShortLink = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'replace_campaign_shortlink',
        mutationFn: (model) => replaceCampaignShortLink(model),
        onSuccess: (data, variables, ctx) => {
            entityUpdater([['campaigns'], ['campaign', data.id]], data);
            notifications.show({
                title: 'Success',
                message: variables.replaceAll
                    ? 'Successfully replaced all shortlinks'
                    : 'Successfully replaced campaign shortlink',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useReplaceCampaignShortLink;
